import React, { Component } from 'react';
import { Tile, BodyText, Link, CaptionText } from '@paypalcorp/pp-react';
import uniq from 'lodash/uniq';
import styles from './hubCharityCard.less';
import OverflowMenu, { OVERFLOW_OPTIONS } from '../OverflowMenu/OverflowMenu';
import trimText from '../../lib/trimText';
import * as analytics from '../../lib/analytics';
export default class HubCharityCard extends Component {
  componentDidMount() {
    const { authState } = JSON.parse(
      document.getElementById('data-props').innerHTML
    );
    const { country: contentCountry } = JSON.parse(
      document.getElementById('data-locale').innerHTML
    );
    analytics.instance.recordEvent(analytics.events.DW_GIVING_TILE_SHOWN, {
      e: 'im',
      item_name: 'dw_giving',
      account_type: authState === 'ANONYMOUS' ? 'guest' : 'member',
      state: 'populated',
      scope: 'tile',
      module: 'charity',
      tile_id: this.props.charity.nonprofit_id,
      card_type: 'charity',
      tile_id_type: 'crid',
      charityName: this.props.charity.name || '',
      lcid: '-', // TODO Check how to get the lcid
      acct_cntry: contentCountry,
      order: this.props.testId,
    });

    analytics.instance.recordEvent(analytics.events.DW_GIVING_TILE_LOADED, {
      e: 'im',
      item_name: 'dw_giving',
      account_type: authState === 'ANONYMOUS' ? 'guest' : 'member',
      state: 'populated',
      scope: 'tile',
      module: 'charity',
      tile_id: this.props.charity.nonprofit_id,
      card_type: 'charity',
      tile_id_type: 'crid',
      charityName: this.props.charity.name || '',
      lcid: '-', // TODO Check how to get the lcid
      acct_cntry: contentCountry,
      order: this.props.testId,
    });
  }

  charityCategories(categories) {
    // display categories in one line, append with ... when the total category string length is beyond 28

    let displayLength = this.props.isMobile ? 44 : 28;
    let categoryString = '';
    for (let i = 0; i < categories.length; i++) {
      categoryString = categoryString + categories[i];
      if (categoryString.length > displayLength) {
        categoryString = trimText(displayLength, categoryString);
        return (
          <CaptionText size='md' className={styles.categoryDisplay}>
            {categoryString}
          </CaptionText>
        );
      } else {
        if (i === categories.length - 1) {
          return (
            <CaptionText size='md' className={styles.categoryDisplay}>
              {categoryString}
            </CaptionText>
          );
        }
        categoryString = categoryString + ', ';
      }
    }
  }

  handleKeyPressOnCharity(e) {
    if (e.key === 'Enter') {
      this.props.viewCharity();
    }
  }

  render() {
    const causeAreas = this.props.causeArea;
    let categories = [];
    if (Array.isArray(causeAreas)) {
      categories =
        uniq(
          causeAreas.map((causeArea) =>
            this.props.i18n(`label.category-${causeArea.id}`)
          )
        ) || [];
    }

    return (
      <div
        onClick={() => this.props.viewCharity()}
        id={this.props.locatorId || `nemo_charity_card_${this.props.testId}`}
        onKeyDown={this.handleKeyPressOnCharity.bind(this)}
        tabIndex='0'
        role='link'
      >
        <Tile className={styles.charityCard} card>
          <OverflowMenu
            name={this.props.i18n('label.menuAllyText1')}
            hubFlow={true}
            fptiInfo={this.props.fptiInfo}
            options={[
              {
                label:
                  this.props.menuOption ||
                  this.props.i18n('label.overFlowMenuList1'),
                value: OVERFLOW_OPTIONS.MORE_INFO,
              },
            ]}
            onOptionChanged={(value) => {
              if (value === OVERFLOW_OPTIONS.MORE_INFO) {
                this.props.handleLearnMoreClick();
                const url = new URL(window.location);
                url.pathname =
                  this.props.npoUrl || `/fundraiser/charity/${this.props.npid}`;
                window.open(url, '_blank');
                return;
              }
            }}
          />
          <Tile.Content className={styles.charityCardContent}>
            <div
              className={styles.cardImage}
              style={{
                background: `url(${this.props.logo_url}) no-repeat center, center`,
                backgroundSize: 'contain',
              }}
            />
            <div className={styles.charityTextClamp}>
              <BodyText size='lg' className={styles.charityNameClamp}>
                {this.props.name}
              </BodyText>
              {/* {this.charityCategories(categories)} */}
              <CaptionText size='md' className={styles.charityNameClamp}>
                {categories.join(', ')}
              </CaptionText>
            </div>
          </Tile.Content>
        </Tile>
      </div>
    );
  }
}
